import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AppRoutes, companyRoute } from '../../app.routes';
import { UserService } from '../../services/api/user/user.service';
import { CompanyService } from '../../services/api/company/company.service';
import { Company } from '../../models/company';
import { ModalService } from '../../services/ui/modal/modal.service';
import { AddCompanyPage } from '../../flows/add-company/add-company.page';
import { first } from 'rxjs';
import { LoadingService } from '../../services/ui/loading/loading.service';

export interface MenuItem {
  label: string,
  icon?: string,
  isActive?: boolean;
}

@Component({
    selector: 'ysh-main-header',
    templateUrl: './ysh-main-header.component.html',
    styleUrl: './ysh-main-header.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CommonModule,
        RouterModule,
        MatIconModule,
        MatTooltipModule
    ]
})
export class YshMainHeaderComponent {
  @Input() userName: string;
  @Input() activeMobileMenu: boolean;
  @Output() onTapLogout = new EventEmitter();
  @Output() onTapMobileMenu = new EventEmitter();

  appRoutes = AppRoutes;
  isCompanyMenuOpen: boolean = false;
  emailSupport = "mailto:support@yoshimobility.com?subject=Portal%20Help";

  constructor(
    public userService: UserService,
    public companyService: CompanyService,
    private modalService: ModalService,
    private loadingService: LoadingService,
    public router: Router,
  ){}

  private updateSelectedCompany(company: Company, loading?: boolean) {
    this.companyService.setSelectedCompany(company);
    this.router.navigateByUrl(AppRoutes.Root, { skipLocationChange: true });
    loading && this.loadingService.loadingShow(500);
  }
  
  toggleCompanyMenu(event: Event) {
    if (event.currentTarget === event.target) {
      this.isCompanyMenuOpen = !this.isCompanyMenuOpen;
    }
  }

  didTapCompany = (company: Company) => {
    this.updateSelectedCompany(company, true);
    this.isCompanyMenuOpen = false;
  }

  didTapAddCompany() {
    this.isCompanyMenuOpen = false;
    this.modalService.present({
      component: AddCompanyPage,
      componentProps: {
        onComplete: (company: Company) => {
          this.userService.getUser().pipe(first()).subscribe(() => {
            this.updateSelectedCompany(company);
          });
        }, 
      }
    });
  }

  didTapLogout() {
    this.onTapLogout.emit();
  }

  didTapMobileMenu() {
    this.onTapMobileMenu.emit();
  }
}
